import { render, staticRenderFns } from "./Form165_v2.vue?vue&type=template&id=83b84a00&scoped=true&"
import script from "./Form165_v2.vue?vue&type=script&lang=js&"
export * from "./Form165_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form165_v2.vue?vue&type=style&index=0&id=83b84a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b84a00",
  null
  
)

export default component.exports